import type { ConfidenceCheckerSummaryResponse } from "@nlc/shared-types";

import apiClient from "@/lib/api/client";

export function getConfidenceCheckerSummary(
  requestId: number,
): Promise<ConfidenceCheckerSummaryResponse> {
  return apiClient
    .url(`/file-evaluations/${requestId}/summary`)
    .get()
    .json<ConfidenceCheckerSummaryResponse>();
}
